import type { sinistres as Fr } from '../fr/sinistres';

/** « sinistres » in English — typed on the French: a missing sentence does not compile. */
export const sinistres: typeof Fr = {
  enregistre: 'Claim recorded.',
  erreur: 'Error',
  titre: 'Accidents',
  sousTitre: 'Clause 06 calculator — the rule applied is spelled out in full',
  circonstancesMontants: 'Circumstances and amounts',
  vehicule: 'Vehicle',
  choisir: 'Choose…',
  circonstances: 'Circumstances',
  cases: {
    ivresse: 'Driving under the influence', faitVolontaire: 'Deliberate act',
    negligence: 'Negligence', locataireFautif: 'Renter 100% at fault',
  },
  aucuneCase: 'No box ticked = renter not at fault: the 60% rule applies.',
  carrosserie: (d: string) => `Bodywork quote (${d})`,
  mecanique: (d: string) => `Mechanical quote (${d})`,
  mainOeuvreDevise: (d: string) => `Labour (${d})`,
  jours: 'Days off the road',
  tarifJour: (d: string) => `Daily rate (${d})`,
  assurance: (d: string) => `Covered by insurance (${d})`,
  recit: 'What happened',
  recitAide: 'Where, how, who was driving, what the accident report says. This account is what will be reread in a dispute.',
  recitExemple: 'E.g. went off the road on the RN5 near Réghaïa, wet road, joint accident report signed, no third party.',
  resultat: 'Result',
  chargeLocataire: 'Payable by the renter',
  reparation: 'Repair',
  mainOeuvre: 'Labour',
  immobilisation: 'Downtime',
  enregistrer: 'Record the claim',
  reserve: 'You can simulate as much as you like. Recording a claim is a financial operation: it is reserved for the owner.',
  enregistres: 'Recorded claims',
  aucun: 'No claims',
  col: { date: 'Date', vehicule: 'Vehicle', regle: 'Rule applied', part: 'Renter’s share', caution: 'Deducted from deposit', reste: 'Balance due' },
  constat: 'Report',
  note: 'Charging 60% to a renter who is not at fault is a commercially aggressive clause: it is yours, and it is applied as written. It is also the one that causes the most disputes — the photographed check-out inspection remains your best protection.',
};
